import auth from 'src/router/auth'

import Carrier from '../Carrier'
import NewCarrier from '../NewCarrier'
import EditCarrier from '../EditCarrier'

export default [
  {
    path: '/carriers',
    name: 'carrier',
    component: Carrier,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/carriers/new',
    name: 'create-carrier',
    component: NewCarrier,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/carriers/:id/edit',
    name: 'edit-carrier',
    component: EditCarrier,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/carrier/routes/index.js